/**
 * Wallet reducer
 */
import {
  computeWalletDerivativeState,
  getNetworkFlags,
  joinWalletBalances,
} from './helpers';

export enum WalletActions {
  LoadWallet = 'WALLET_LOAD_DATA',
  SetWallet = 'WALLET_SET_DATA',
  ResetWallet = 'WALLET_RESET_DATA',
  ToggleWalletError = 'WALLET_TOGGLE_ERROR',
  JoinWalletBalances = 'WALLET_JOIN_BALANCES',
}

export interface IWalletToken {
  name: string;
  fullName: string;
  contract: string;
  decimals: number;
  balance: number;
  icon: string;
  isNative: boolean;
}

export type WalletTokenRatesBySym = Record<string, number>;
export type WalletTokenBalancesBySym = Record<string, number>;
export type WalletTokenBalancesByAddr = Record<string, number>;
export type WalletTokenRatesByAddr = Record<string, number>;
export type WalletTokensByAddr = Record<string, IWalletToken>;
export type WalletTokensBySym = Record<string, IWalletToken>;

export interface IWalletState {
  // User state
  chain: number;
  account: string;
  // Network flags
  isEVM: boolean;
  isTron: boolean;
  isElrond: boolean;
  // UI state
  loading: boolean;
  error: boolean;
  // Derivative indexes
  tokenRatesBySym: WalletTokenRatesBySym;
  tokenBalancesBySym: WalletTokenBalancesBySym;
  tokenBalancesByAddr: WalletTokenBalancesByAddr;
  tokenRatesByAddr: WalletTokenRatesByAddr;
  tokensByAddr: WalletTokensByAddr;
  tokensBySym: WalletTokensBySym;
}

export const defaultWalletState: IWalletState = {
  chain: 0,
  account: '',
  loading: false,
  error: false,
  isEVM: false,
  isTron: false,
  isElrond: false,
  tokenRatesBySym: {},
  tokenBalancesBySym: {},
  tokenBalancesByAddr: {},
  tokenRatesByAddr: {},
  tokensByAddr: {},
  tokensBySym: {},
};

const walletReducer = (
  state: IWalletState,
  action: { payload?: any; type: WalletActions }
): IWalletState => {
  switch (action.type) {
  case WalletActions.LoadWallet:
    return {
      ...state,
      loading: true,
      error: false,
      chain: action.payload.chain,
      account: action.payload.account,
      ...getNetworkFlags(action.payload.chain),
    };
  case WalletActions.SetWallet:
    return computeWalletDerivativeState(state, action.payload);
  case WalletActions.ResetWallet:
    return defaultWalletState;
  case WalletActions.ToggleWalletError:
    return {
      ...state,
      loading: false,
      error: true,
    };
  case WalletActions.JoinWalletBalances:
    return joinWalletBalances(state, action.payload);
  default:
    return state;
  }
};

export default walletReducer;
